import { Injectable } from '@angular/core';
import { ClientService, ClientTheme } from '@cm/core/client';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class CmThemeService {
	/** @deprecated Use `ClientService.theme$` instead. */
	client$: Observable<ClientTheme> = this.clientService.theme$;

	constructor(private readonly clientService: ClientService) {}
}
